import '@/polyfills'
import '@/assets/main.css'
import { createApp } from 'vue'
import App from './App.vue'
import { initSentry } from '@/monitoring/sentry'
import router from '@/router'
import { i18n } from '@/i18n'

const app = createApp(App)

initSentry(app, router)

app
  .use(router)
  .use(i18n)
  .mount('#app')
